export default __webpack_public_path__ + "static/media/Zugite Knight Totem.0f1a8c9f.jpg";